<template>
  <section id="intro">
    <div class="container">
      <div class="row">
        <div align="left" class="col-sm-12 col-md-8">
          <div class="intro-content box">
            <h2>About Timeshare Resales</h2>
            <p>
              Uni-Vate Properties found that there was a desperate need for a reputable source for
              buyers and sellers to turn to with their timeshare needs in South Africa.
            </p>
          </div>
        </div>
      </div>
    </div>

    <carousel
      :nav="false"
      :dots="false"
      :items="1"
      :autoplay="true"
      :loop="true"
      id="intro-carousel"
      style="margin-top:-50px"
      :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
    >
      <img
        class="item"
        src="/img/intro-carousel/timeshare-1.jpg"
        style="object-fit: cover"
        alt=""
      />
      <img
        class="item"
        src="/img/intro-carousel/timeshare-2.jpg"
        style="object-fit: cover"
        alt=""
      />
      <img
        class="item"
        src="/img/intro-carousel/timeshare-3.jpg"
        style="object-fit: cover"
        alt=""
      />
      <img
        class="item"
        src="/img/intro-carousel/timeshare-4.jpg"
        style="object-fit: cover"
        alt=""
      />
      <img
        class="item"
        src="/img/intro-carousel/timeshare-5.jpg"
        style="object-fit: cover"
        alt=""
      />
      <img
        class="item"
        src="/img/intro-carousel/timeshare-6.jpg"
        style="object-fit: cover"
        alt=""
      />
    </carousel>

    <div id="intro-carousel" class="owl-carousel"></div>
  </section>
</template>

<script>
/* eslint-disable */

import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel
  }
};
</script>

<style lang="scss" scoped></style>
